import { ensureValidDecimalsPrecision } from '../../../../../helpers/DecimalsPrecisionHelpers';
import useExperimentDetailsTemplateState from '@experiment-details/hooks/useExperimentDetailsTemplateState';
import { DEFAULT_DECIMAL_PRECISION } from '@experiment-management-shared/constants/experimentGridConstants';

const useMetricDecimalsPrecision = () => {
  const [
    decimalsPrecision,
    setDecimalsPrecision
  ] = useExperimentDetailsTemplateState(
    `metrics.decimalsPrecision`,
    DEFAULT_DECIMAL_PRECISION
  );

  const onChangeDecimalsPrecision = (value: number) => {
    setDecimalsPrecision(value);
  };

  return {
    decimalsPrecision: ensureValidDecimalsPrecision(decimalsPrecision),
    onChangeDecimalsPrecision
  };
};

export default useMetricDecimalsPrecision;
